export default __webpack_public_path__ + "static/media/Settings-1.09f476eb.svg";